import { render, staticRenderFns } from "./SmsIndex.vue?vue&type=template&id=54934684"
import script from "./SmsIndex.vue?vue&type=script&lang=js"
export * from "./SmsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports